import { ActionList, ActionMenu } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { useCommonContext } from '../../contexts/common';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { chuyenKhoaApi } from '../../api/chuyenKhoaApi';
import { ts_hocsinh_lichsu_yte_chuyenkhoa } from '../../models/response/category/ts_hocsinh_lichsu_yte_chuyenkhoa';
import { NotifyHelper } from '../../helpers/toast';

type ComboboxChuyenKhoaProps = {
    isReadonly?: boolean;
    value?: string;
    onValueChanged: (value: string, data?: ts_hocsinh_lichsu_yte_chuyenkhoa) => void;
    className?: string;
    isShowClearButton?: boolean;
    preText?: string;
    width?: string | number;
    stylingMode?: 'outlined' | 'filled' | 'underlined';
};

export const ComboboxChuyenKhoa = (props: ComboboxChuyenKhoaProps) => {
    const [chuyenKhoaList, setChuyenKhoaList] = useState<ts_hocsinh_lichsu_yte_chuyenkhoa[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const { translate } = useCommonContext();
    const { dm_coso_id } = useCommonSelectedHook();

    const loadChuyenKhoa = async () => {
        try {
            setIsLoading(true);
            const response = await chuyenKhoaApi.selectAll();
            if (response.is_success) {
                // Lọc theo dm_coso_id
                const filteredData = (response.data || []).filter((item: ts_hocsinh_lichsu_yte_chuyenkhoa) => item.dm_coso_id === dm_coso_id);
                setChuyenKhoaList(filteredData);
            } else {
                NotifyHelper.Error("Có lỗi khi tải danh sách chuyên khoa");
            }
        } catch (error: any) {
            NotifyHelper.Error(error.message || "Có lỗi khi tải danh sách chuyên khoa");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadChuyenKhoa();
    }, [dm_coso_id]);

    const dataSource = useMemo(() => {
        return chuyenKhoaList.map(x => ({ 
            value: x.id.toString(), 
            text: x.ten_chuyenkhoa + (x.ten_chuyenkhoa_en ? ` (${x.ten_chuyenkhoa_en})` : ""),
            data: x
        }));
    }, [chuyenKhoaList]);

    const selectedData = useMemo(() => {
        if (props.value && dataSource) {
            return dataSource.find(x => x.value === props.value);
        }
        return undefined;
    }, [dataSource, props.value]);

    return (
        <div style={{ width: '100%' }}>
            <ActionMenu>
                <ActionMenu.Button
                    aria-label="Chọn chuyên khoa"
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                    disabled={props.isReadonly || isLoading}
                >
                    {selectedData ? selectedData.text : translate("Chọn chuyên khoa")}
                </ActionMenu.Button>
                <ActionMenu.Overlay width="small">
                    <ActionList selectionVariant="single">
                        {props.isShowClearButton &&
                            <ActionList.Item 
                                key={0} 
                                selected={!props.value || props.value === ""}
                                onSelect={() => {
                                    props.onValueChanged("")
                                }}
                            >
                                {"Chọn chuyên khoa"}
                            </ActionList.Item>
                        }
                        {dataSource && dataSource.map((item) => {
                            return (
                                <ActionList.Item 
                                    key={item.value} 
                                    selected={props.value !== undefined && item.value === props.value}
                                    onSelect={() => {
                                        props.onValueChanged(item.value, item.data)
                                    }}
                                >
                                    {item.text}
                                </ActionList.Item>
                            );
                        })}
                    </ActionList>
                </ActionMenu.Overlay>
            </ActionMenu>
        </div>
    );
};
